// removed by extract-text-webpack-plugin
module.exports = {"optionsWrap":"qempo_DIYCourier_optionsWrap-2QpssS1","option":"qempo_DIYCourier_option-1jRuwpp","active":"qempo_DIYCourier_active-26ldmed","hidden":"qempo_DIYCourier_hidden-3sDqGlv","content":"qempo_DIYCourier_content-qZYjRIN","courierInfoWrap":"qempo_DIYCourier_courierInfoWrap-2QpESeC","textWrap":"qempo_DIYCourier_textWrap-2X-USfe","courierName":"qempo_DIYCourier_courierName-Nvnq8Hj","location":"qempo_DIYCourier_location-3k0mTdp","shipping":"qempo_DIYCourier_shipping-1SHcQRN","shippingDays":"qempo_DIYCourier_shippingDays-2BPU9Bs"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/QuoteStep/components/DIYCourier/DIYCourier.scss
// module id = 1707
// module chunks = 0